export default {
    title_list: 'Платежи',
    title_page: 'Платеж',
    title_create_page: 'Создать платеж',
    title_edit_page: 'Изменить платеж',

    filter: {
        labels: {
            user_id: 'Пользователь',
            subscribe_id: 'Подписка',
            braintree_id: 'Braintree ID',
        }
    },

    table: {
        labels: {
            id: 'ID',
            user_id: 'Пользователь',
            subscribe_id: 'Тип платежа',
            braintree_id: 'Braintree ID',
            cost: 'Стоимость',
        }
    },

    buttons: {

    },

    form: {
        user_id: 'Пользователь',
        subscribe_id: 'Подписка',
        gift_id: 'Подарок',
        concierge_id: 'Консьерж сервис',
        braintree_id: 'Braintree ID',
        cost: 'Стоимость',
        card_mask: 'Карта',
        card_type: 'Тип карты',
    },
}
